import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';

export const NewEmployeeGlidepath = () => {
    const employeeGlidepath = [
        { metricName: 'Metric 1', col1: '75%', col2: '75%', col3: '75%', col4: '75%', col5: '75%' },
        { metricName: 'Metric 2', col1: '80%', col2: '80%', col3: '80%', col4: '80%', col5: '80%' },
        { metricName: 'Metric 3', col1: '90%', col2: '90%', col3: '90%', col4: '90%', col5: '90%' },
    ] as any;

    const renderMetricName = (rowData: any) => {
        return (
                <strong>{rowData?.metricName}</strong>
        );
    };

    const renderHeader = () => {
        return <div className="text-center">New Employee Glidepath</div>;
    };

    const header = renderHeader();

    return (
        <DataTable value={employeeGlidepath} header={header}>
            <Column field="metricName" header="Metric Name" body={renderMetricName} />
            <Column field="col1" header="1" />
            <Column field="col2" header="2" />
            <Column field="col3" header="3" />
            <Column field="col4" header="4" />
            <Column field="col5" header="5" />
        </DataTable>
    );
};
